import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useModals } from "ModalProvider";
import moment from "moment";
import { Link } from "react-router-dom";
import ForecastCategoryFormView from "./ForecastCategoryFormView";
import { DELETE_FORECAST_CATEGORY } from "./graphql";

const ForecastCategoryCardView = ({ category, onChanged, readOnly }) => {
  const modal = useModals();
  const [deleteForecastCategory, deleteForecastCategoryRes] = useMutation(
    DELETE_FORECAST_CATEGORY,
    {
      onCompleted() {
        Alert("success", "Category deleted.");
        onChanged?.();
      },
      onError(error) {
        window.alert(parseError(error));
      },
    },
  );

  function editCategory() {
    modal.present({
      title: "Edit Forecast Category",
      children: (
        <ForecastCategoryFormView
          category={category}
          onCompleted={() => {
            modal.hide();
            onChanged?.();
          }}
        />
      ),
    });
  }

  function deleteCategory() {
    if (!window.confirm("Are you sure to delete this category?")) return;
    deleteForecastCategory({
      variables: { id: category.id },
    });
  }

  console.log("category?", category);

  return (
    <div className="card flex flex-col">
      <div className="font-semibold opacity-50 text-xs">
        {category.connectionType === "NO"
          ? "Manual"
          : category.connectionType === "CUSTOMER"
            ? "Customer"
            : "Warehouse"}
      </div>
      <div className="flex justify-between items-baseline">
        <h5>{category.name}</h5>
      </div>
      <div className="mt-2 space-y-1 flex-1">
        <div>
          <span className="opacity-70">Products:</span>{" "}
          {category.products?.length || 0}
        </div>
        {category.description && (
          <div className="mt-1 whitespace-nowrap">{category.description}</div>
        )}

        {category.lastSubmission ? (
          <div>
            Last Submitted at{" "}
            {moment(category.lastSubmission.submittedAt).format(
              "YYYY-MM-DD HH:mm:ss",
            )}
          </div>
        ) : (
          <div className="opacity-70">No Submissions.</div>
        )}
      </div>

      <div className="mt-4 flex justify-between items-end">
        <div className="grid gap-2">
          <Link to={category.id}>Submit Forecast</Link>
          <Link to={`${category.id}/submissions`}>View Submit History</Link>
        </div>
        {!readOnly && (
          <div className="flex items-center justify-between space-x-4 opacity-70">
            <Button edit onClick={editCategory} />
            <Button
              trash
              onClick={deleteCategory}
              loading={deleteForecastCategoryRes.loading}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ForecastCategoryCardView;
